import * as e from "react";
const s = /*#__PURE__*/ e.createContext({
    isMobile: !1,
    isTablet: !1,
    isTabletOrBigger: !1,
    isTabletOrSmaller: !1,
    isDesktopOrBigger: !1,
    isLargeDesktop: !1
}), t = s;
export { t as default };
